import {DeleteButton} from '../../_kit';

export function DeleteTeacherButtonMultipleSelect() {
	return <DeleteButton disabled tooltipMessage='Select only one item for deletion.' whenShowTooltip='disabled' />;
}
